import * as React from 'react';
import { createContext, useContext, useState } from 'react';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export type XDPRedesignPhase1ContextType = {
  enableXDPRedesignPhase1: boolean;
};

export const XDPRedesignPhase1Context = createContext<XDPRedesignPhase1ContextType>({
  enableXDPRedesignPhase1: false,
});

function XDPRedesignPhase1Provider({ children }: React.PropsWithChildren) {
  const [experimentValue] = useState(GrowthDiscoveryEpicClient.get('enableXDPRedesignPhase1'));

  return (
    <XDPRedesignPhase1Context.Provider value={{ enableXDPRedesignPhase1: experimentValue }}>
      {children}
    </XDPRedesignPhase1Context.Provider>
  );
}

export const useXDPRedesignPhase1Data = () => {
  return useContext(XDPRedesignPhase1Context) || { enableXDPRedesignPhase1: false };
};

export default XDPRedesignPhase1Provider;
